var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconFileImageComponent(props, ref) {
  var prefixFromContext = useContext(Context).prefix;
  var _a = props.className,
    className = _a === void 0 ? '' : _a,
    prefixFromProps = props.prefix,
    _b = props.width,
    width = _b === void 0 ? '1em' : _b,
    _c = props.height,
    height = _c === void 0 ? '1em' : _c,
    _d = props.useCurrentColor,
    useCurrentColor = _d === void 0 ? true : _d,
    rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor"]);
  var prefix = prefixFromProps || prefixFromContext || 'arco';
  return /*#__PURE__*/React.createElement("svg", __assign({
    className: "".concat(prefix, "-icon ").concat(prefix, "-icon-file-image ").concat(className),
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    fill: useCurrentColor ? 'currentColor' : '#000',
    xmlns: "http://www.w3.org/2000/svg"
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6664 7.83331C11.4947 7.83331 12.1662 7.16182 12.1662 6.3335C12.1662 5.50517 11.4947 4.83368 10.6664 4.83368C9.8381 4.83368 9.16661 5.50517 9.16661 6.3335C9.16661 7.16182 9.8381 7.83331 10.6664 7.83331Z",
    fillOpacity: "1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.33423 4.33374C1.33423 3.22931 2.22955 2.33398 3.33398 2.33398H12.6662C13.7706 2.33398 14.6659 3.22931 14.6659 4.33374V11.6662C14.6659 12.7706 13.7706 13.6659 12.6662 13.6659H3.33398C2.22955 13.6659 1.33423 12.7706 1.33423 11.6662V4.33374ZM3.33398 3.66716C2.96584 3.66716 2.6674 3.9656 2.6674 4.33374V8.84408L3.96551 7.54597C4.6915 6.81998 5.86858 6.81998 6.59458 7.54597L11.3814 12.3328H12.6662C13.0343 12.3328 13.3328 12.0343 13.3328 11.6662V4.33374C13.3328 3.9656 13.0343 3.66716 12.6662 3.66716H3.33398ZM2.6674 11.6662C2.6674 12.0343 2.96584 12.3328 3.33398 12.3328H9.49598L5.65188 8.48867C5.44652 8.28331 5.11356 8.28331 4.9082 8.48867L2.6674 10.7295V11.6662Z",
    fillOpacity: "1"
  }));
}
var IconFileImage = /*#__PURE__*/React.forwardRef(IconFileImageComponent);
export default IconFileImage;